import {randomFromArray} from '../../../helpers/random-from-array.js'

//SLOWING is offensively using attacks that lower enemy stats. EX: Lowering an enemy's accuracyModifier
export function getSlowingPath(casterModel, teamCombatants=[], enemyCombatants=[], casterActions=[]) {

  //See if we have valid Slowing attacks
  const validMoves = casterActions.filter(action => {

    //Accuracy lowering
    if (action.affectTargetAccuracyModifier < 0) {
      return true;
    }

    //TODO: Attack/Defense/Speed lowering [offensive] attacks
    //At this time, those do not exist. Only in the "boosting" realm, which is a defensive/positive thing

    return false;
  });
  if (!validMoves.length) {
    return null
  }

  //Return a random one of our valid moves
  const action = randomFromArray(validMoves);

  //Choose one random ALIVE enemy (because the list includes all dead or alive enemies)
  const target = randomFromArray(enemyCombatants.filter(model => model.isAlive()));

  return {
    actionModel: action,
    casterModel: casterModel,
    targetModels: [target]
  }
}


// WEBPACK FOOTER //
// ./src/battle/bot-decisions/personality-paths/get-slowing-path.js